// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Dashboard from 'Containers/Dashboard/Dashboard';

const StyledDashboardPage = styled.div`
  display: block;
`;

const DashboardPage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let dashboardPageClassName = bodyAttributes?.class || '';
  if (!dashboardPageClassName.includes('DashboardPage')) {
    dashboardPageClassName += 'DashboardPage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ t('common.pages.dashboard') }</title>
        <body className={ dashboardPageClassName } />
      </Helmet>
      <StyledDashboardPage theme={ theme } className="grid-container">
        <Dashboard />
      </StyledDashboardPage>
    </>
  );
});
DashboardPage.displayName = 'DashboardPage';

export default DashboardPage;
